import Main from "niteroi/packages/sales-distribution/controllers/Main.controller";

export default class Dashboard extends Main {
    public onInit(): void {
        super.onInit();
    }

    public onCreateBusinessPartnerPress(): void {
        this.navTo("sales-distribution/business-partners", {}, false);
    }

    public onCreateQuotationPress(): void {
        this.navTo("sales-distribution/quotations", {}, false);
    }

    public onCreateSalesOrderPress(): void {
        this.navTo("sales-distribution/orders", {}, false);
    }

    public onCreateDeliveryNotePress(): void {
        this.navTo("sales-distribution/deliveries", {}, false);
    }

    public onCreateInvoicePress(): void {
        this.navTo("sales-distribution/invoices", {}, false);
    }

    public onCreateCreditPress(): void {
        this.navTo("sales-distribution/credits", {}, false);
    }
}
